// 第1報の各ステップで使用する文言を定義
export const FIRST_REPORT_TEXTS = {
  inputter: {
    step01: {
      descriptions: [
        "誤りがない場合：STEP2に進んでください。",
        "誤りがある場合：正しい情報を入力し、STEP2に進んでください。"
      ]
    },
    step02: {
      title: "STEP2：様式ダ−3用の点検実施",
      lead: "「震度」「点検実施箇所」を確認してください。",
      descriptions: [
        "誤りがない場合：STEP3に進んでください。",
        "誤りがある場合：正しい情報を入力し、STEP3に進んでください。"
      ]
    },
    step03: {
      title: "STEP3：様式１用の点検実施",
      lead: "ダム・発電所の点検をしてください。",
      descriptions: [
        "設備異常がない場合：表示されている内容を確認し、誤りがなければSTEP4に進んでください。",
        "設備異常がある場合：「設備異常有無」「異常有設備名」「状況及び臨時点検実施状況等」を入力し、STEP4に進んでください。"
      ]
    },
    step04: {
      title: "STEP4：報告書作成",
      lead: '報告内容を確認し、問題がなければ「報告内容を確認しました」にチェックを入れてください。<br />「報告書作成」ボタンをクリックし、報告書をダウンロードしてください。<br /> ダウンロードした報告書を確認し、STEP5に進んでください。',
      descriptions: [
        "ダウンロードされるファイル：様式１（20240701改正：新様式）第１報、様式ダ−3（大分河川国道事務所 殿）第１報"
      ]
    },
    step05: {
      title: "STEP5：承認依頼申請",
      lead: "「承認依頼」ボタンをクリックしてください。<br />ボタンクリック後は、承認結果が返ってくるまでお待ち下さい。",
    }
  },
  reviewer: {
    step01: {
      descriptions: [
        "報告内容に誤りがない場合：表示されている内容を確認し、誤りがなければSTEP2に進んでください。",
        "報告内容に誤りがある場合：「差し戻し」ボタンをクリックし、差し戻し理由を記載してください。"
      ]
    },
    step02: {
      title: "STEP2：様式ダ−3用の点検結果確認",
      lead: "ダムの点検結果を確認してください。",
      descriptions: [
        "報告内容に誤りがない場合：表示されている内容を確認し、誤りがなければSTEP3に進んでください。",
        "報告内容に誤りがある場合：「差し戻し」ボタンをクリックし、差し戻し理由を記載してください。"
      ]
    },
    step03: {
      title: "STEP3：様式１用の点検結果確認",
      lead: "ダム・発電所の点検結果を確認してください。",
      descriptions: [
        "報告内容に誤りがない場合：表示されている内容を確認し、誤りがなければSTEP4に進んでください。",
        "報告内容に誤りがある場合：「差し戻し」ボタンをクリックし、差し戻し理由を記載してください。"
      ]
    },
    step04: {
      title: "STEP4：報告書様式での確認",
      lead: "「報告書ダウンロード」ボタンをクリックしてください。",
    },
    step05: {
      title: "STEP5：承認",
      lead: "ダウンロードした「様式１（20240701改正：新様式） 第１報」「様式ダ−3（大分河川国道事務所殿）第１報」を確認してください。",
      descriptions: [
        "報告書に誤りがない場合：表示されている内容を確認し、誤りがなければ「承認」ボタンをクリックしてください。",
        "報告書に誤りがある場合：「差し戻し」ボタンをクリックし、差し戻し理由を記載してください。"
      ]
    }
  }
};

// 第1報の送信後タスクで使用する文言を定義
export const FIRST_REPORT_POST_SEND_TASKS_TEXTS = {
  status13: {
    title: "国土交通省 大分河川国道事務所へ「報告書を添付したメールを送付した」旨の電話連絡をしてください",
    appealContent: "河川管理課 外線：0975-44-4167、 携帯：090-8761-0261",
    lead: "電話連絡が終わったら「次へボタン」をクリックし次の業務を実施してください",
  },
  status14: {
    title: "水力運営グループへ「第1報」をTeamsで報告してください",
    appealContent: "Teams連絡先：非常災害時等の情報共有（水力関係） 05 大分水力センター⇔水力運営グループ",
    lead: "Teamsで連絡が終わったら「次へボタン」をクリックし次の業務を実施してください",
  },
  status15: {
    title: "1次点検を開始",
    lead: "「1次点検を開始」ボタンをクリックし1次点検を実施してください。",
    buttonContent: "1次点検を開始",
  }
};

// 1次点検の各ステップで使用する文言を定義
export const PRIMARY_INSPECTION_TEXTS = {
  inputter: {
    step01: {
      title: "STEP1：基本情報",
      lead: "「地震発生日時」「最大震度」「震源地」を確認してください。",
      descriptions: [
        "誤りがない場合：STEP2に進んでください。",
        "誤りがある場合：正しい情報を入力し、STEP2に進んでください。"
      ]
    },
    step02: {
      title: "STEP2：点検概要",
      lead: "点検概要を入力および確認してください。<br />入力および確認後、STEP3に進んでください。<br />",
      descriptions: [
        "入力項目：「前回点検年月日」、「点検開始時間」、「点検終了時間」、「点検者」",
        "確認項目：「点検年月日」、「点検要因」、「ダム地点震度」"
      ]
    },
    step03: {
      title: "STEP3：ダム本体点検結果",
      lead: "ダムの点検をしてください。",
      descriptions: [
        "設備異常がない場合：表示されている内容を確認し、誤りがなければSTEP4に進んでください。",
        "設備異常がある場合：「外観異常なし」の左にあるチェックボックスをクリック後「状況」を入力し、STEP4に進んでください。"
      ]
    },
    step04: {
      title: "STEP4：報告書作成",
      lead: "報告内容を確認し、問題がなければ「報告内容を確認しました」にチェックを入れてください。<br />「報告書作成」ボタンをクリックし、報告書をダウンロードしてください。<br /> ダウンロードした報告書を確認し、STEP5に進んでください。",
      descriptions: [
        "ダウンロードされるファイル：様式ダ−3（大分河川国道事務所殿）１次点検、地震様式−Ａ（大分河川国道事務所殿）１次点検"
      ]
    },
    step05: {
      title: "STEP5：承認依頼申請",
      lead: "「承認依頼」ボタンをクリックしてください。<br />ボタンクリック後は、承認結果が返ってくるまでお待ち下さい。",
    }
  },
  reviewer: {
    step01: {
      title: "STEP1：基本情報",
      lead: "「地震発生日時」「最大震度」「震源地」を確認してください。",
      descriptions: [
        "報告内容に誤りがない場合：表示されている内容を確認し、誤りがなければSTEP3に進んでください。",
        "報告内容に誤りがある場合：「差し戻し」ボタンをクリックし、差し戻し理由を記載してください。"
      ]
    },
    step02: {
      title: "STEP2：点検概要",
      lead: "点検概要を確認してください。<br />",
      descriptions: [
        "報告内容に誤りがない場合：表示されている内容を確認し、誤りがなければSTEP3に進んでください。",
        "報告内容に誤りがある場合：「差し戻し」ボタンをクリックし、差し戻し理由を記載してください。"
      ]
    },
    step03: {
      title: "STEP3：ダム本体点検結果",
      lead: "ダムの点検をしてください。",
      descriptions: [
        "報告内容に誤りがない場合：表示されている内容を確認し、誤りがなければSTEP3に進んでください。",
        "報告内容に誤りがある場合：「差し戻し」ボタンをクリックし、差し戻し理由を記載してください。"
      ]
    },
    step04: {
      title: "STEP4：報告書様式での確認",
      lead: "「報告書ダウンロード」ボタンをクリックしてください。<br />",
    },
    step05: {
      title: "STEP5：承認",
      lead: "ダウンロードした「様式ダ−3（大分河川国道事務所殿）１次点検」「地震様式−Ａ（大分河川国道事務所殿）１次点検」を確認してください。",
      descriptions: [
        "報告書に誤りがない場合：表示されている内容を確認し、誤りがなければ「承認」ボタンをクリックしてください。",
        "報告書に誤りがある場合：「差し戻し」ボタンをクリックし、差し戻し理由を記載してください。"
      ]
    }
  }
};

// 第1次点検の送信後タスク文言
export const PRIMARY_INSPECTION_POST_SEND_TASKS_TEXTS = {
  status16: {
    title: "国土交通省 大分河川国道事務所へ「報告書を添付したメールを送付した」旨の電話連絡をしてください。",
    appealContent: "河川管理課 外線：0975-44-4167、 携帯：090-8761-0261",
    lead: "電話連絡が終わったら「次へボタン」をクリックし次の業務を実施してください"
  },
  status17: {
    title: "水力運営グループへ「1次点検」をTeamsで報告してください",
    appealContent: "Teams連絡先：非常災害時等の情報共有（水力関係） 05 大分水力センター⇔水力運営グループ",
    listItems: [
      "様式ダー３と地震様式Ａは新しく最新のものを添付してください",
      "様式１はすでに添付している資料を修正してください"
    ],
    lead: "Teamsで報告が終わったら「次へボタン」をクリックし次の業務を実施してください"
  },
  status18: {
    title: "2次点検を開始",
    lead: "「2次点検を開始」ボタンをクリックし2次点検を実施してください。",
    buttonContent: "2次点検を開始",
  }
};

// 2次点検の各ステップで使用する文言を定義
export const SECONDARY_INSPECTION_TEXTS = {
  inputter: {
    step01: {
      title: "STEP1：基本情報",
      lead: "「地震発生日時」「最大震度」「震源地」を確認してください。",
      descriptions: [
        "誤りがない場合：STEP2に進んでください。",
        "誤りがある場合：正しい情報を入力し、STEP2に進んでください。"
      ]
    },
    step02: {
      title: "STEP2：点検概要",
      lead: "点検概要を入力および確認してください。<br />入力および確認後、STEP3に進んでください。<br />",
      descriptions: [
        "入力項目：「前回点検年月日」、「点検開始時間」、「点検終了時間」、「点検者」",
        "確認項目：「点検年月日」、「点検要因」、「ダム地点震度」"
      ]
    },
    step03: {
      title: "STEP3：ダム本体点検結果",
      lead: "ダムの点検をしてください。",
      descriptions: [
        "設備異常がない場合：表示されている内容を確認し、誤りがなければSTEP4に進んでください。",
        "設備異常がある場合：「外観異常なし」の左にあるチェックボックスをクリック後「状況」を入力し、STEP4に進んでください。"
      ]
    },
    step04: {
      title: "STEP4：報告書作成",
      lead: "報告内容を確認し、問題がなければ「報告内容を確認しました」にチェックを入れてください。<br />「報告書作成」ボタンをクリックし、報告書をダウンロードしてください。<br /> ダウンロードした報告書を確認し、STEP5に進んでください。",
      descriptions: [
        "ダウンロードされるファイル：様式ダ−3（大分河川国道事務所殿）２次点検、地震様式−Ａ（大分河川国道事務所殿）２次点検"
      ]
    },
    step05: {
      title: "STEP5：承認依頼申請",
      lead: "「承認依頼」ボタンをクリックしてください。<br />ボタンクリック後は、承認結果が返ってくるまでお待ち下さい。",
    }
  },
  reviewer: {
    step01: {
      title: "STEP1：基本情報",
      lead: "「地震発生日時」「最大震度」「震源地」を確認してください。",
      descriptions: [
        "報告内容に誤りがない場合：表示されている内容を確認し、誤りがなければSTEP3に進んでください。",
        "報告内容に誤りがある場合：「差し戻し」ボタンをクリックし、差し戻し理由を記載してください。"
      ]
    },
    step02: {
      title: "STEP2：点検概要",
      lead: "点検概要を確認してください。<br />",
      descriptions: [
        "報告内容に誤りがない場合：表示されている内容を確認し、誤りがなければSTEP3に進んでください。",
        "報告内容に誤りがある場合：「差し戻し」ボタンをクリックし、差し戻し理由を記載してください。"
      ]
    },
    step03: {
      title: "STEP3：ダム本体点検結果",
      lead: "ダムの点検をしてください。",
      descriptions: [
        "報告内容に誤りがない場合：表示されている内容を確認し、誤りがなければSTEP3に進んでください。",
        "報告内容に誤りがある場合：「差し戻し」ボタンをクリックし、差し戻し理由を記載してください。"
      ]
    },
    step04: {
      title: "STEP4：報告書様式での確認",
      lead: "「報告書ダウンロード」ボタンをクリックしてください。<br />",
    },
    step05: {
      title: "STEP5：承認",
      lead: "ダウンロードした「様式ダ−3（大分河川国道事務所殿）２次点検」「地震様式−Ａ（大分河川国道事務所殿）２次点検」を確認してください。",
      descriptions: [
        "報告書に誤りがない場合：表示されている内容を確認し、誤りがなければ「承認」ボタンをクリックしてください。",
        "報告書に誤りがある場合：「差し戻し」ボタンをクリックし、差し戻し理由を記載してください。"
      ]
    }
  }
};

// 2次点検の送信後タスク文言
export const SECONDARY_INSPECTION_AFTER_APPROVAL_TASK = {
  status19: {
    title: "国土交通省 大分河川国道事務所へ「報告書を添付したメールを送付した」旨の電話連絡をしてください。",
    appealContent: "河川管理課 外線：0975-44-4167、 携帯：090-8761-0261",
    lead: "電話連絡が終わったら「次へボタン」をクリックし次の業務を実施してください"
  },
  status20: {
    title: "水力運営グループへ「2次点検」をTeamsで報告してください",
    appealContent: "Teams連絡先：非常災害時等の情報共有（水力関係） 05 大分水力センター⇔水力運営グループ",
    listItems: [
      "様式ダー３と地震様式Ａは新しく最新のものを添付してください",
      "様式１はすでに添付している資料を修正してください"
    ],
    lead: "Teamsで連絡が終わったら「次へボタン」をクリックし次の業務を実施してください"
  },
  status21: {
    title: "報告業務を完了",
    lead: "「報告業務を完了」ボタンをクリックし報告業務を完了してください。",
    buttonContent: "報告業務を完了"
  },
};

// 2次点検の送信後タスク文言
export const POWERPLANT_TASK = {
  step1: {
    title: "STEP1：「水路抜水必須発電所」と「水路抜水任意発電所」の地震対応業務を実施",
    lead: "発電所の地震対応が完了したら、STEP2に進んでください。"
  },
  step2: {
    title: "STEP2：発電所の地震対応業務を完了",
    lead: "「全発電所発電再開」ボタンをクリックし地震対応業務を完了してください。",
  },
};